<div class="flex gap-2">
  <app-pan-button color="info" icon="list" (click)="openModal()" matTooltip="Kiosk Transactions"></app-pan-button>

  <app-pan-button color="danger" icon="delete" (click)="params.deleteCallback(params.data)" matTooltip="Remove Kiosk"></app-pan-button>
</div>

<app-pan-modal #kioskDisplayCheck size="sm" [topLevel]="true" [shouldBodyScroll]="false">
  <div header>{{ params.data.name }} Transactions</div>
  <div body class="max-h-[300px] overflow-scroll">
    @if (params.loadingTransactions()) {
      <app-pan-blank-slate>
        <app-pan-spinner size="lg"></app-pan-spinner>
      </app-pan-blank-slate>
    } @else {
      @if (params.kioskTransactions().length === 0) {
        <app-pan-inline-alert type="info">This kiosk has no transactions.</app-pan-inline-alert>
      } @else {
        <app-pan-section-header class="mb-2" [title]="'Kiosk Transaction Preview'"></app-pan-section-header>
      }
    }
    @for (trans of params.kioskTransactions(); track $index) {
      <app-pan-card>
        <div class="font-bold relative min-h-8 flex items-center">
          {{ trans.trans_id }}

          <app-pan-transaction-type
            [state]="trans.type === 'sold' ? 'Sold' : 'Cancel'"
            class="absolute right-[-16px]"
          ></app-pan-transaction-type>
        </div>
        <div>{{ trans.product_name }}</div>
        <div class="italic text-sm">{{ trans.trans_date | date: "medium" }}</div>
      </app-pan-card>
    }


  </div>
  <div footer>
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>
